import { Json, Result } from 'types';
import * as schemaBuilder from 'type-schema';

/** User 是實際在系統上有註冊的人 */
export type User = schemaBuilder.buildType<typeof User.schema>;

export namespace User {
    export const schema = schemaBuilder.object({
        id: schemaBuilder.string(),
        name: schemaBuilder.string(),
        email: schemaBuilder.string(),
        consent: schemaBuilder.string(),
    });

    export function fromJson (user: Json): Result<string, User> {
        const [ error, value ] = schemaBuilder.transform(schema, user);
        if (error) {
            return Result.fail(error);
        } else {
            return Result.ok({
                id: value.id,
                name: value.name,
                email: value.email,
                consent: value.consent,
            });
        }
    }
}
